import React from "react";
import { Table, Button } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import NothingToShow from "../NothingToShow";
import CustomModal from "../CustomModal";
import FuncaoDetailModal from "../FuncaoDetailModal";

const TabelaPlanejamentoFuncoes = ({ currentTab, edit, funcoes, total, dadosPlanejamento, setDadosPlanejamento, allFuncoes }) => {

    const openModalFunction = (title, item) => {
        CustomModal.show({
            title: title,
            body: (
                <FuncaoDetailModal
                    dadosPlanejamento={dadosPlanejamento}
                    setDadosPlanejamento={setDadosPlanejamento}
                    currentTab={currentTab}
                    item={item}
                    edit={edit}
                    allFuncoes={allFuncoes}
                    onCancel={() => CustomModal.hide()}
                />
            )
        })
    }

    return (
        <>
            <div className="d-flex justify-content-between mb-2">
                <h4>Funções</h4>

                {edit &&
                    <Button onClick={() => openModalFunction("Nova Função")} disabled={!edit}><FaPlus /></Button>
                }
            </div>

            <Table striped>
                <thead>
                    <tr>
                        <th className="list-header" style={{width: "17%"}}>Tipo</th>
                        <th className="list-header" style={{width: "6%"}}>Horas</th>
                        <th className="list-header" style={{width: "6%"}}>Taxa de Custo</th>
                        <th className="list-header" style={{width: "6%"}}>Total</th>
                        <th className="list-header" style={{width: "19%"}}>Observações</th>
                    </tr>
                </thead>

                <tbody>
                    {funcoes.length > 0 ?
                        <>
                            {funcoes.map((item, index) => (
                                <tr key={index} className="list-row cursor-pointer-row" onClick={() => openModalFunction(edit ? "Editar Função" : "Detalhes Função", item)}>
                                    <td className="list-row-cell">{item.nome_funcao}</td>
                                    <td className="list-row-cell">{parseFloat(item.horas_funcao)}h</td>
                                    <td className="list-row-cell">{new Intl.NumberFormat('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    }).format(item.custo_venda_funcao)}</td>
                                    <td className="list-row-cell">{new Intl.NumberFormat('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL'
                                    }).format(item.custo_total_funcao)}</td>
                                    <td className="list-row-cell">{item.observacao}</td>
                                </tr>
                            ))}
                            <tr className="list-row">
                                <td className="list-row-cell font-weight-bold">Total</td>
                                <td className="list-row-cell font-weight-bold">{parseFloat(total?.soma_horas_funcao).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}h</td>
                                <td className="list-row-cell font-weight-bold"></td>
                                <td className="list-row-cell font-weight-bold">{total?.soma_custo_total_funcao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                <td className="list-row-cell font-weight-bold"></td>
                            </tr>
                        </>
                        :
                        <tr className="list-row">
                            <td className="list-row-cell" colSpan={5}><NothingToShow /></td>
                        </tr>}
                </tbody>
            </Table>
        </>
    )
};

export default TabelaPlanejamentoFuncoes;
